import { Trans } from "react-i18next";
import { Modal, ModalContent, ModalTitle, useMuiModal } from "./modal";
import { Button } from "./ui/button";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export function ClosingWarningModal({
  onContinue,
}: {
  onContinue: () => void;
}) {
  useAudioSlot("modal.closing-warning");
  const { closeModal } = useMuiModal();
  return (
    <Modal>
      <ModalTitle>
        <Trans>Figyelem!</Trans>
      </ModalTitle>
      <ModalContent>
        <p className="leading-6">
          <Trans>
            Hamarosan zárunk! Ha most mosógépet indítasz, előfordulhat, hogy nem
            lesz lehetőséged szárítógépet indítani a mosás befejezése után.
          </Trans>
        </p>
        <div className="flex gap-6">
          <Button onClick={closeModal} variant="outline">
            <Trans>Vissza</Trans>
          </Button>
          <Button
            className="px-2 w-max"
            onClick={() => {
              closeModal();
              onContinue();
            }}
          >
            <Trans>Értettem, tovább</Trans>
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
